import * as Sentry from '@sentry/browser';

import loadConfiguration from 'configuration/loadConfiguration';
import fetchConfigSuccess from 'actions/configuration/fetchConfigSuccess';
import isDocumentHidden from 'lib/isDocumentHidden';

export default (async function fetchConfiguration(dispatch, getState) {
  const { appId, cdn } = getState().app;

  if (isDocumentHidden()) {
    return;
  }

  try {
    const configuration = await loadConfiguration(cdn, appId);
    return dispatch(fetchConfigSuccess(configuration));
  } catch (error) {
    Sentry.captureMessage(`fetch configuration error: ${error}`);
  }
});
